import { Flashbar, Button, Table, TablePagination, TablePropertyFiltering, TableSorting } from 'AWS-UI-Components-React';
import ButtonDropdown from "@amzn/awsui-components-react/polaris/button-dropdown";
import React from 'react';
import { getJSClient } from '../../js_client';
import { V2_PROPERTY_FILTERING_TEXT } from '../../common/property_filter_helpers';

const ColumnDefinitions = [
  {
    id: 'month',
    header: 'Month',
    cell: (item) => item.month,
  },
  {
    id: 'account',
    header: 'Account',
    cell: (item) => item.account,
  },
  {
    id: 'marketplace',
    header: 'Marketplace',
    cell: (item) => item.marketplace,
  },
  {
    id: 'channel',
    header: 'Channel',
    cell: (item) => item.channel,
  },
  {
    id: 'pl',
    header: 'PL',
    cell: (item) => item.pl,
  },
  {
    id: 'amount',
    header: 'Amount',
    cell: (item) => Math.round(item.amount * 10000) / 10000,
  },
  {
    id: 'comments',
    header: 'Comments',
    cell: (item) => item.comments,
  },
  {
    id: 'originalAmount',
    header: 'Original Amount',
    cell: (item) => item.originalAmount,
  },
  {
    id: 'originalComments',
    header: 'Original Comments',
    cell: (item) => item.originalComments,
  },
  {
    id: 'updateRecord',
    header: 'Is Update Record',
    cell: (item) => item.updateRecord,
  },
];

export class BenchmarkAdjustmentDraftTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ''
    }
  }

  componentDidMount = () => {
    this.client = getJSClient();
  }

  getFilter = (draftItems) => {
    let monthOptions = new Set();
    let accountOptions = new Set();
    let marketplaceOptions = new Set();
    let channelOptions = new Set();
    let plOptions = new Set();
    let updateRecordOptions = new Set();
    if(draftItems) {
      draftItems.forEach(draftItem => {
        monthOptions.add(draftItem.month);
        accountOptions.add(draftItem.account);
        marketplaceOptions.add(draftItem.marketplace);
        channelOptions.add(draftItem.channel);
        plOptions.add(draftItem.pl);
        updateRecordOptions.add(draftItem.updateRecord);
      });
    }
    return [
      {
        groupValuesLabel: 'Month',
        propertyKey: 'month',
        propertyLabel: 'Month',
        values: Array.from(monthOptions),
      },
      {
        groupValuesLabel: 'Account',
        propertyKey: 'account',
        propertyLabel: 'Account',
        values: Array.from(accountOptions),
      },
      {
        groupValuesLabel: 'Marketplace',
        propertyKey: 'marketplace',
        propertyLabel: 'Marketplace',
        values: Array.from(marketplaceOptions),
      },
      {
        groupValuesLabel: 'Channel',
        propertyKey: 'channel',
        propertyLabel: 'Channel',
        values: Array.from(channelOptions),
      },
      {
        groupValuesLabel: 'PL',
        propertyKey: 'pl',
        propertyLabel: 'PL',
        values: Array.from(plOptions),
      },
      {
        groupValuesLabel: 'Is Update Record',
        propertyKey: '_updateRecordText',
        propertyLabel: 'Is Update Record',
        values: Array.from(new Set(Array.from(updateRecordOptions).map((flag) => (flag ? 'Yes' : 'No')))),
      }
    ];
  }

  onDraftDiscard = () => {
    this.client.discardBenchmarkAdjustmentDraft(
      (result) => {this.onDraftDiscardSuccess(result)},
    (error) => {this.onDraftDiscardFailure(error)},
      {username: this.props.user});
  }

  onDraftDiscardSuccess = (result) => {
    if(result.failedBenchmarkAdjustmentDraftItems.length !== 0) {
      this.setState({errorMessage: `${result.failedBenchmarkAdjustmentDraftItems.length} items were not deleted, 
      please try again.`})
    }
    this.props.refreshDraft()
  }

  onDraftDiscardFailure = (error) => {
    this.setState({errorMessage: `Fail to discard draft, please try again: ${error}`})
  }

  onPublish = () => {
    this.client.publishBenchmarkAdjustment(
      (result) => {this.onPublishSuccess(result)},
      (error) => {this.onPublishFailure(error)},
      {username: this.props.user});
  }

  onPublishSuccess = (result) => {
    if(result.failedBenchmarkAdjustmentDraftItems.length !== 0) {
      this.setState({errorMessage: `${result.failedBenchmarkAdjustmentDraftItems.length} items were not published, 
      please try again.`})
    }
    this.props.refreshDraft()
  }

  onPublishFailure = (error) => {
    this.setState({errorMessage: `Fail to publish draft, please try again: ${error}`})
  }

  render() {
    const {
      draftItems,
      loading,
      downloadTemplate,
      onUpload
    } = this.props;
    const {
      errorMessage,
    } = this.state;
    // v2 property filtering matches strings, so expose boolean updateRecord via a 'Yes'/'No' search alias.
    const searchableDraftItems = (draftItems || []).map((draftItem) => ({
      ...draftItem,
      _updateRecordText: draftItem.updateRecord ? 'Yes' : 'No',
    }));
    return (
      <div>
        <Flashbar items={errorMessage ? [
          {
            type: 'error',
            content: `${errorMessage}`,
            dismissible: true
          }] : [] }
        />
      <Table
        columnDefinitions={ColumnDefinitions}
        items={searchableDraftItems}
        empty={<b>Draft is empty</b>}
        loadingText="Loading Benchmark Adjustment Draft..."
        loading={loading}
        stickyHeader
        header={
          <div className="awsui-util-action-stripe">
            <div className="awsui-util-action-stripe-title">
              <h2>Benchmark Adjustment Draft  <span className="awsui-util-header-counter">({ draftItems.length })</span></h2>
            </div>
            <div className="awsui-util-action-stripe-group">
              <Button
                icon = "refresh"
                onClick={this.props.refreshDraft}
              />
              <ButtonDropdown
                variant="primary"
                disabled={draftItems.length === 0}
                expandableGroups={false}
                items={[{ id: 'confirm', text: 'Confirm Publish', disabled: false }]}
                onItemClick= {this.onPublish}
              >
                Publish
              </ButtonDropdown>
              <ButtonDropdown
                disabled={draftItems.length === 0}
                expandableGroups={false}
                items={[{ id: 'confirm', text: 'Confirm Discard', disabled: false }]}
                onItemClick= {this.onDraftDiscard}
              >
                Discard
              </ButtonDropdown>
              <Button
                text="Upload"
                icon="upload"
                onClick={onUpload}
              />
              <Button
                text="Download Template"
                icon="download"
                onClick={downloadTemplate}
              />
            </div>
          </div>
        }
      >
        <TablePagination pageSize={25} />
        <TablePropertyFiltering
          {...V2_PROPERTY_FILTERING_TEXT}
          filteringOptions={this.getFilter(searchableDraftItems)}
          placeholder="Filter Benchmark Adjustment Draft"
        />
        <TableSorting
          sortingColumn='month'
          sortableColumns={ [
            {id: 'month', field: 'month'},
            {id: 'account', field: 'account'},
            {id: 'marketplace', field: 'marketplace'},
            {id: 'channel', field: 'channel'},
            {id: 'pl', field: 'pl'}
          ] }
        />
      </Table>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/config_central/benchmark_adjustment/benchmark_adjustment_draft_table.jsx